import React from 'react';

// A button's name inside a sentence (Nic 2026-10-10): drawn like a small key
// so "tap Yes, it happened" reads as a button, not as more words.
const ButtonName = ({ children }) => (
  <span className="mx-px inline-flex items-center whitespace-nowrap rounded-md bg-white px-1.5 py-px align-baseline text-[0.92em] font-semibold leading-snug text-slate-800 shadow-[0_1px_0_rgba(15,23,42,0.08)] ring-1 ring-slate-300/80 dark:!bg-white/10 dark:text-slate-100 dark:ring-white/20">
    {children}
  </span>
);

export default ButtonName;
